import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NavController, NavParams, AlertController, Events } from 'ionic-angular';
import { GlobalConfig } from '../../app/app.config';
import { EventData } from '../../providers/event';
import { GroupByPipe } from '../../pipes/group-by';
import { Translate } from '../../providers/translate';
import { EventDiaryPage } from '../../pages/event-diary/event-diary';
import { Observable} from 'rxjs/Observable';

@Component({
  selector: 'event-diary',
  templateUrl: 'event-diary.html',
  providers: [GroupByPipe, DatePipe]
})

export class EventDiaryComponent {

  obs: any;
  obsDiary: any;
  obsListener: any;
  event: any;
  client: string;
  dataDiary: any = false;
  configData = GlobalConfig;
  componentState: boolean = false;
  configDiary: any = false;
  defaultDate: any = null;

  constructor(public eventProvider: EventData, public params: NavParams, public GroupBy: GroupByPipe, public navCtrl: NavController, public alertCtrl: AlertController, public translate: Translate, events: Events, public datePipe: DatePipe) {

    this.event = this.params.get('event');
    this.client = this.params.get('client');

    this.obsListener = this.eventProvider.getListener(this.client, this.event.id, 'diary').subscribe(stateModule => {
      if (stateModule.$value === true) {
        this.componentState = true;
      } else {
        this.componentState = false;
      }
    });

    this.obs = new Observable(observer => {
      this.obsDiary = this.eventProvider.getListDiary(this.client, this.event.id).subscribe((data: any) => {
        if (data && this.componentState) {
          observer.next(data);
        } else {
          observer.next(false);
        }
      });
    });

    this.obs.subscribe((data) => {
      this.dataDiary = this.GroupBy.transform(data, 'date', true);

      let tmp = [];

      this.dataDiary.forEach(d => {
        tmp.push(d.key);
      });

      tmp.sort().forEach(x => {
        if (this.datePipe.transform(new Date(x), 'yyyy-MM-dd') == this.datePipe.transform(new Date(), 'yyyy-MM-dd')) {
          this.defaultDate = x;
        } else if (this.datePipe.transform(new Date(x), 'yyyy-MM-dd') > this.datePipe.transform(new Date(), 'yyyy-MM-dd')) {
          this.defaultDate = tmp[0];
        } else {
          this.defaultDate = x;
        }
      });
    })

    // close de listener where logout user
    events.subscribe('client:logout', (r) => {
      this.closeListener();
    });
  }

  showDates() {
    let textTranslate: any;
    let alert = this.alertCtrl.create();

    this.translate.translateGroup(['Seleccione una fecha', 'Cancelar', 'Ok']).
    then(result => {
      textTranslate = result;

      this.dataDiary.forEach((diary) => {
        alert.addInput({
          type: 'radio',
          label: diary.key,
          value: diary.key,
          checked: diary.key == this.defaultDate ? true : false
        });
      });

      alert.setTitle(textTranslate['Seleccione una fecha']);

      alert.addButton(textTranslate['Cancelar']);

      alert.addButton({
        text: textTranslate['Ok'],
        handler: data => {
          this.defaultDate = data;
        }
      });

      alert.present();
    })

  }

  viewDiary(diary) {
    this.navCtrl.push(EventDiaryPage, {event: this.event, diary: diary, client: this.client});
  }

  closeListener(primaryListener = false) {
    if (this.obsListener && !primaryListener) {
      console.log('Se eliminan los observables de Diary');
      this.obsListener.unsubscribe();
    }
    if (this.obsDiary) {
      this.obsDiary.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/components/event-diary/event-diary.ts